//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    tab: {
      type: Object,
      required: true
    }
  }
};
